import { render } from "./ObjectiveSectionDefine.vue?vue&type=template&id=1948deef&scoped=true"
import script from "./ObjectiveSectionDefine.vue?vue&type=script&lang=js"
export * from "./ObjectiveSectionDefine.vue?vue&type=script&lang=js"

import "./ObjectiveSectionDefine.vue?vue&type=style&index=0&id=1948deef&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1948deef"]])

export default __exports__